import React from "react";

import { TFunction } from "utils";

import { GOAL_LEVEL_2, Goal } from "models";

import { Flex, Table, Typography } from "components";

import { useCropMixComposerContext } from "pages/app/crop-mix-composer/CropMixComposerContextProvider.tsx";
import { CropMixComposerMultiSelect } from "pages/app/crop-mix-composer/components/CropMixComposerMultiSelect.tsx";

export const GoalsSelection = ({ items, maxSelectableItems, t }: { items: Goal[]; maxSelectableItems: number; t: TFunction }) => {
  const { selectedGoals, setSelectedGoals, isChangingStep } = useCropMixComposerContext();

  const handleChange = (item: GOAL_LEVEL_2) => {
    // if we are waiting for the step to change, we don't want the user to be able to change the goals
    if (isChangingStep !== null) return;

    const exists = selectedGoals.includes(item);
    if (exists) {
      const selectedGoalsUpdated = selectedGoals.filter((currentItems) => currentItems !== item);
      setSelectedGoals(selectedGoalsUpdated);
    } else {
      if (selectedGoals.length >= maxSelectableItems) return;

      const selectedGoalsUpdated = [...selectedGoals];
      selectedGoalsUpdated.push(item);
      setSelectedGoals(selectedGoalsUpdated);
    }
  };

  const goalsData = items.map((item, index) => ({
    key: `crop-mix-composer-overlay-goal-${item.level1}-${index}`,
    label: (
      <Flex gap="1rem">
        <Typography variant="paragraph-l" data-testid={`cmc-goal-level-1-icon-${item.level1}`} className="margin-0">
          {item.emoji}
        </Typography>
        <Typography variant="paragraph-l" data-testid={`cmc-goal-level-1-icon-${item.level1}`} className="margin-0">
          {t(`goals.${item.level1}`)}
        </Typography>
      </Flex>
    ),
    goals: (
      <CropMixComposerMultiSelect
        items={item.level2.map((value) => ({ name: t(`goals.${value}`), value: value }))}
        selectedItems={selectedGoals}
        onSelectionChanged={(value) => handleChange(value as GOAL_LEVEL_2)}
        dataTestId={`goal-${item.level1}`}
      />
    ),
  }));

  return (
    <Flex data-testid="crop-mix-composer-overlay-goals-container" vertical={true}>
      <div>
        <Table
          className="crop-mix-composer-goals-table"
          columns={[
            {
              title: "Label",
              dataIndex: "label",
              key: "label",
            },
            {
              title: "Goals",
              dataIndex: "goals",
              key: "goals",
            },
          ]}
          data={goalsData}
          hideHeader={true}
        />
      </div>
    </Flex>
  );
};
